export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';
//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const DEFAULT_HOSPITAL_INFO = 'default-hospital-info';
export const HOSPITAL_ACTIVITIES = 'hospital-activities';
export const PATIENT_STATISTICS = 'patient-statistics';
export const HRM_BASIC_DATA = 'hrm-basic-data';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/profile';
export const All_NOTIFICATION = '/historie';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '../app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';

// Hiring, onboarding
export const DATATABLE_DATA = 'crud';
export const DATATABLE_SEARCH_SELECT = '/datatable/name';
export const DATATABLE_CANDIDATES_SEARCH_SELECT = '/datatable/residence';
export const DATATABLE_CANDIDATES_DATA = 'admin/app/candidates';
export const TAGS_DATA = 'admin/app/tags';
export const SKILLS_DATA = 'admin/app/skills';
export const JOBS_DATA = 'admin/app/jobs';
export const TIMELINE_DATA = 'admin/app/candidates-total';
export const TIMELINE_STATES_DATA = 'admin/app/timeline-states';
export const CANDIDATES_EVENTS_DATA = 'admin/app/candidates-events';
export const CANDIDATES_ONBOARDING_EVENTS_DATA = 'admin/app/candidates-onboarding-events';
export const CANDIDATES_ONBOARDING_ANNIVERSARY = 'admin/app/event-stats';
export const CANDIDATES_ONBOARDING_BIRTHDAY = 'admin/app/birthdate-stats';


// Careers (URL /adverts/ is blocked by AdBlock by default)
export const DATATABLE_CAREERS_DATA = 'admin/app/careers';
export const DATATABLE_CAREERS_URL = 'jobs';
export const DATATABLE_CAREERS_TEMPLATE_URL = 'job-templates';
export const SITE_CAREERS_URL = 'careersite';
export const SITE_CAREERS_DATA = 'admin/app/careersites';


// Onboarding
export const DATATABLE_ONBOARDING_URL = '/onboarding';
export const SITE_ONBOARDING_URL = '/onboarding/stranka?id=';
export const SITE_ONBOARDING_DATA = 'admin/app/onboardingsites';
export const DATATABLE_ONBOARDING_CHECKLIST_URL = '/onboarding/checklist';


// Courses
export const DATATABLE_COURSES_DATA = 'admin/app/courses';
export const DATATABLE_COURSES_URL = 'courses';


// Forms
export const DATATABLE_FORMS_DATA = 'admin/app/forms';
export const FORM_RESULTS_DATA = 'admin/app/form-results'; 
export const DATATABLE_FORMS_URL = 'forms';


// Templates
export const DATATABLE_TEMPLATES_DATA = 'admin/app/templates';
export const DATATABLE_MAIL_TEMPLATES_URL = 'mail-templates';


// Files
export const FILES_ATTACHMENT_DATA = 'files/attachment';

// Comments
export const COMMENTS_DATA = 'admin/app/comments/';

// Checklists
export const CHECKLISTS_DATA = 'admin/app/checklists';
export const DATATABLE_CHECKLISTS_DATA = 'admin/app/checklists';

// Graphs
export const TIMELINE_STATS = 'admin/app/candidates-stats';
export const CAREER_RESPONSES_STATS = 'admin/app/career-responses-stats';
export const CAREER_SOURCES_STATS = 'admin/app/career-sources-stats';
export const CAREER_SOURCES_DETAIL_STATS = 'admin/app/career-sources-detail-stats';
export const CAREER_EMPLOYEES_STATS = 'admin/app/career-employees-stats';
export const CAREER_EMPLOYEES_DETAIL_STATS = 'admin/app/career-employees-detail-stats';
export const EMPLOYEES_OVERVIEW_STATS = 'admin/app/employees-overview-stats';

//roles and users
export const USERS_AND_ROLES = '../users-and-roles';
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

// Membership
export const MEMBERSHIP = '/membership';
